export const MODULE_LIST = {
  CLIENT: 'CLIENT',
  PROJECT: 'PROJECT',
  CLIENT_KNOW_BANK: 'CLIENT_KNOW_BANK',
  PROJ_KNOW_BANK: 'PROJ_KNOW_BANK',
  PROJ_KNOW_SHARING: 'PROJ_KNOW_SHARING',
  WORKROOM: 'WORKROOM',
  CONVERSATION: 'CONVERSATION',
  ACTIVATION: 'ACTIVATION',
  SILOS: 'SILOS',
  PROJECT_TIMELINE: 'PROJECT_TIMELINE',
};